import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { setQueryTypeFilter } from '../../../../store/benchmark/slice';
import Select from '../../../../components/UI/Select/Select';
import { QueryType } from '../../../../types/QueryTypes';

const QueryTypeFilter: React.FC = () => {
  const dispatch = useDispatch();
  const queryType = useSelector((state: RootState) => state.benchmark.filters.query_type);

  const options = Object.values(QueryType).map((type) => ({
    value: type,
    label: type,
  }));

  const handleChange = (value: QueryType | undefined) => {
    dispatch(setQueryTypeFilter(value));
  };

  return (
    <Select<QueryType>
      label="Query Type"
      value={queryType}
      onChange={handleChange}
      options={options}
      placeholder="Select query type"
      isClearable
    />
  );
};

export default QueryTypeFilter;
